// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Auth pages (login, signup, forgot/reset password) — new menu palette.
 * Matches src/assets/scss/_new-theme-overrides.scss (\$new-theme-primary #1F2937).
 * Requires \`eb-new-theme\` on <html> (see src/lib/applyAuthNewTheme.ts).
 */
html.eb-new-theme {
  --eb-auth-primary: #1f2937;
  --eb-auth-primary-hover: #111827;
  --eb-auth-accent-light: #f0f0f0;
  --eb-auth-accent-light-hover: #e5e5e5;
  --eb-auth-outline-border: #e5e5e5;
  --eb-auth-link: #377dff;
  --eb-auth-link-hover: #2f6ad9;
}

html.eb-new-theme,
html.eb-new-theme body {
  color: var(--eb-auth-primary);
}

/* Buttons: theme text colors only (!important beats base \`a { color: #377dff }\`) */
html.eb-new-theme .btn-primary,
html.eb-new-theme a.btn-primary,
html.eb-new-theme .btn-primary:hover,
html.eb-new-theme .btn-primary:focus,
html.eb-new-theme a.btn-primary:hover,
html.eb-new-theme a.btn-primary:focus {
  color: #fff !important;
  background-color: var(--eb-auth-primary);
  border-color: var(--eb-auth-primary);
}

html.eb-new-theme .btn-primary:hover,
html.eb-new-theme .btn-primary:focus,
html.eb-new-theme a.btn-primary:hover,
html.eb-new-theme a.btn-primary:focus {
  background-color: var(--eb-auth-primary-hover);
  border-color: var(--eb-auth-primary-hover);
}

html.eb-new-theme .btn.btn-active-primary,
html.eb-new-theme a.btn.btn-active-primary {
  color: var(--eb-auth-primary) !important;
  background-color: var(--eb-auth-accent-light);
}

html.eb-new-theme .btn.btn-active-primary:hover:not(.btn-active),
html.eb-new-theme a.btn.btn-active-primary:hover:not(.btn-active) {
  color: #fff !important;
  border-color: var(--eb-auth-primary);
  background-color: var(--eb-auth-primary);
}

/* OAuth / btn-light (G Suite, Microsoft, Shopify) — light bg, subtle darker hover */
html.eb-new-theme .btn.btn-light,
html.eb-new-theme a.btn.btn-light,
html.eb-new-theme .google-btn,
html.eb-new-theme a.google-btn {
  color: var(--eb-auth-primary) !important;
  background-color: var(--eb-auth-accent-light) !important;
  border-color: var(--eb-auth-accent-light) !important;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

html.eb-new-theme .btn.btn-light:hover,
html.eb-new-theme .btn.btn-light:focus,
html.eb-new-theme a.btn.btn-light:hover,
html.eb-new-theme a.btn.btn-light:focus,
html.eb-new-theme .google-btn:hover,
html.eb-new-theme .google-btn:focus,
html.eb-new-theme a.google-btn:hover,
html.eb-new-theme a.google-btn:focus {
  color: var(--eb-auth-primary) !important;
  background-color: var(--eb-auth-accent-light-hover) !important;
  border-color: var(--eb-auth-accent-light-hover) !important;
}

html.eb-new-theme .btn.btn-outline-light,
html.eb-new-theme button.btn.btn-outline-light,
html.eb-new-theme a.btn.btn-outline-light {
  color: var(--eb-auth-primary) !important;
  background-color: #f5f5f5 !important;
  border-color: var(--eb-auth-outline-border) !important;
}

html.eb-new-theme .btn.btn-outline-light:hover,
html.eb-new-theme .btn.btn-outline-light:focus,
html.eb-new-theme .btn.btn-outline-light:active,
html.eb-new-theme button.btn.btn-outline-light:hover,
html.eb-new-theme button.btn.btn-outline-light:focus,
html.eb-new-theme a.btn.btn-outline-light:hover,
html.eb-new-theme a.btn.btn-outline-light:focus {
  color: var(--eb-auth-primary) !important;
  background-color: #ffffff !important;
  border-color: var(--eb-auth-outline-border) !important;
  box-shadow: none !important;
}

/* Plain text links (not .btn) stay brand blue */
html.eb-new-theme a:not(.btn):not(.pwd-field-icon-underline) {
  color: var(--eb-auth-link) !important;
}

html.eb-new-theme a:not(.btn):not(.pwd-field-icon-underline):hover {
  color: var(--eb-auth-link-hover) !important;
}

html.eb-new-theme .form-control:focus {
  border-color: var(--eb-auth-primary);
  box-shadow: none;
}

html.eb-new-theme .form-select:focus {
  border-color: var(--eb-auth-primary);
  box-shadow: none;
}

/* Custom dropdown (see commons/components/DropdownSelect.tsx).
   The trigger reuses .form-control.form-select, so only the list needs styles. */
.eb-dropdown-select {
  position: relative;
}

/* Hidden required input: invisible but still validated, so the browser's "required" bubble anchors here */
.eb-dropdown-select-input {
  position: absolute;
  inset: 0;
  opacity: 0;
  pointer-events: none;
}

.eb-dropdown-select-trigger {
  text-align: left;
  cursor: pointer;
}

.eb-dropdown-select-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 20;
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid var(--eb-auth-primary, #1f2937);
  border-top: 0;
  border-radius: 0 0 0.375rem 0.375rem;
  /* clip the highlighted last option to the rounded corners so it can't paint over the bottom border */
  overflow: hidden;
}

.eb-dropdown-select-option {
  padding: 0.5rem 1rem;
  color: #212529;
  cursor: pointer;
}

/* Old theme keeps the browser-style blue highlight; new theme uses the light grey */
.eb-dropdown-select-option.active {
  background-color: #1a6ad7;
  color: #fff;
}

html.eb-new-theme .eb-dropdown-select-option.active {
  background-color: var(--eb-auth-accent-light);
  color: var(--eb-auth-primary);
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/login-new-theme.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,qCAAqC;EACrC,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA,mFAAmF;AACnF;;;;;;EAME,sBAAsB;EACtB,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;;;;EAIE,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;;EAEE,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA,oFAAoF;AACpF;;;;EAIE,wCAAwC;EACxC,wDAAwD;EACxD,oDAAoD;EACpD,8EAA8E;AAChF;;AAEA;;;;;;;;EAQE,wCAAwC;EACxC,8DAA8D;EAC9D,0DAA0D;AAC5D;;AAEA;;;EAGE,wCAAwC;EACxC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;;;;;;;EAOE,wCAAwC;EACxC,oCAAoC;EACpC,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA,gDAAgD;AAChD;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;iFACiF;AACjF;EACE,kBAAkB;AACpB;;AAEA,0GAA0G;AAC1G;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,iDAAiD;EACjD,aAAa;EACb,oCAAoC;EACpC,qGAAqG;EACrG,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA,oFAAoF;AACpF;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,6BAA6B;AAC/B","sourcesContent":["/**\n * Auth pages (login, signup, forgot/reset password) — new menu palette.\n * Matches src/assets/scss/_new-theme-overrides.scss ($new-theme-primary #1F2937).\n * Requires `eb-new-theme` on <html> (see src/lib/applyAuthNewTheme.ts).\n */\nhtml.eb-new-theme {\n  --eb-auth-primary: #1f2937;\n  --eb-auth-primary-hover: #111827;\n  --eb-auth-accent-light: #f0f0f0;\n  --eb-auth-accent-light-hover: #e5e5e5;\n  --eb-auth-outline-border: #e5e5e5;\n  --eb-auth-link: #377dff;\n  --eb-auth-link-hover: #2f6ad9;\n}\n\nhtml.eb-new-theme,\nhtml.eb-new-theme body {\n  color: var(--eb-auth-primary);\n}\n\n/* Buttons: theme text colors only (!important beats base `a { color: #377dff }`) */\nhtml.eb-new-theme .btn-primary,\nhtml.eb-new-theme a.btn-primary,\nhtml.eb-new-theme .btn-primary:hover,\nhtml.eb-new-theme .btn-primary:focus,\nhtml.eb-new-theme a.btn-primary:hover,\nhtml.eb-new-theme a.btn-primary:focus {\n  color: #fff !important;\n  background-color: var(--eb-auth-primary);\n  border-color: var(--eb-auth-primary);\n}\n\nhtml.eb-new-theme .btn-primary:hover,\nhtml.eb-new-theme .btn-primary:focus,\nhtml.eb-new-theme a.btn-primary:hover,\nhtml.eb-new-theme a.btn-primary:focus {\n  background-color: var(--eb-auth-primary-hover);\n  border-color: var(--eb-auth-primary-hover);\n}\n\nhtml.eb-new-theme .btn.btn-active-primary,\nhtml.eb-new-theme a.btn.btn-active-primary {\n  color: var(--eb-auth-primary) !important;\n  background-color: var(--eb-auth-accent-light);\n}\n\nhtml.eb-new-theme .btn.btn-active-primary:hover:not(.btn-active),\nhtml.eb-new-theme a.btn.btn-active-primary:hover:not(.btn-active) {\n  color: #fff !important;\n  border-color: var(--eb-auth-primary);\n  background-color: var(--eb-auth-primary);\n}\n\n/* OAuth / btn-light (G Suite, Microsoft, Shopify) — light bg, subtle darker hover */\nhtml.eb-new-theme .btn.btn-light,\nhtml.eb-new-theme a.btn.btn-light,\nhtml.eb-new-theme .google-btn,\nhtml.eb-new-theme a.google-btn {\n  color: var(--eb-auth-primary) !important;\n  background-color: var(--eb-auth-accent-light) !important;\n  border-color: var(--eb-auth-accent-light) !important;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n\nhtml.eb-new-theme .btn.btn-light:hover,\nhtml.eb-new-theme .btn.btn-light:focus,\nhtml.eb-new-theme a.btn.btn-light:hover,\nhtml.eb-new-theme a.btn.btn-light:focus,\nhtml.eb-new-theme .google-btn:hover,\nhtml.eb-new-theme .google-btn:focus,\nhtml.eb-new-theme a.google-btn:hover,\nhtml.eb-new-theme a.google-btn:focus {\n  color: var(--eb-auth-primary) !important;\n  background-color: var(--eb-auth-accent-light-hover) !important;\n  border-color: var(--eb-auth-accent-light-hover) !important;\n}\n\nhtml.eb-new-theme .btn.btn-outline-light,\nhtml.eb-new-theme button.btn.btn-outline-light,\nhtml.eb-new-theme a.btn.btn-outline-light {\n  color: var(--eb-auth-primary) !important;\n  background-color: #f5f5f5 !important;\n  border-color: var(--eb-auth-outline-border) !important;\n}\n\nhtml.eb-new-theme .btn.btn-outline-light:hover,\nhtml.eb-new-theme .btn.btn-outline-light:focus,\nhtml.eb-new-theme .btn.btn-outline-light:active,\nhtml.eb-new-theme button.btn.btn-outline-light:hover,\nhtml.eb-new-theme button.btn.btn-outline-light:focus,\nhtml.eb-new-theme a.btn.btn-outline-light:hover,\nhtml.eb-new-theme a.btn.btn-outline-light:focus {\n  color: var(--eb-auth-primary) !important;\n  background-color: #ffffff !important;\n  border-color: var(--eb-auth-outline-border) !important;\n  box-shadow: none !important;\n}\n\n/* Plain text links (not .btn) stay brand blue */\nhtml.eb-new-theme a:not(.btn):not(.pwd-field-icon-underline) {\n  color: var(--eb-auth-link) !important;\n}\n\nhtml.eb-new-theme a:not(.btn):not(.pwd-field-icon-underline):hover {\n  color: var(--eb-auth-link-hover) !important;\n}\n\nhtml.eb-new-theme .form-control:focus {\n  border-color: var(--eb-auth-primary);\n  box-shadow: none;\n}\n\nhtml.eb-new-theme .form-select:focus {\n  border-color: var(--eb-auth-primary);\n  box-shadow: none;\n}\n\n/* Custom dropdown (see commons/components/DropdownSelect.tsx).\n   The trigger reuses .form-control.form-select, so only the list needs styles. */\n.eb-dropdown-select {\n  position: relative;\n}\n\n/* Hidden required input: invisible but still validated, so the browser's \"required\" bubble anchors here */\n.eb-dropdown-select-input {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.eb-dropdown-select-trigger {\n  text-align: left;\n  cursor: pointer;\n}\n\n.eb-dropdown-select-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  background-color: #fff;\n  border: 1px solid var(--eb-auth-primary, #1f2937);\n  border-top: 0;\n  border-radius: 0 0 0.375rem 0.375rem;\n  /* clip the highlighted last option to the rounded corners so it can't paint over the bottom border */\n  overflow: hidden;\n}\n\n.eb-dropdown-select-option {\n  padding: 0.5rem 1rem;\n  color: #212529;\n  cursor: pointer;\n}\n\n/* Old theme keeps the browser-style blue highlight; new theme uses the light grey */\n.eb-dropdown-select-option.active {\n  background-color: #1a6ad7;\n  color: #fff;\n}\n\nhtml.eb-new-theme .eb-dropdown-select-option.active {\n  background-color: var(--eb-auth-accent-light);\n  color: var(--eb-auth-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
